import { AppComponent } from '../../app.component';
import Helper from 'src/app/core/utility/helper';
import { AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { TeslaGridComponent, GridData } from '@tesla/angular2-tesla-common/tesla-common';
import { TeslaSpinnerComponent } from '@tesla/angular2-tesla-common/spinner/spinner.component';
import { Observable } from 'rxjs';
import { SpinnerComponent } from 'src/app/commonUI/spinner/spinner.component';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { Sort, DataStateChangeEvent } from '@tesla/angular2-tesla-common/grid/grid.models';
import { tap } from 'rxjs/operators';
import { Constants } from '../constants';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import UIHelper from 'src/app/core/utility/ui-helper';
import { SearchFilterCondition } from 'src/app/models/internal/searchfiltercondition';
import { FormGroup } from '@angular/forms';
import { SourceType } from 'src/app/models/sourcetype';
import { NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { InfoButtonDisplayDTO } from '../../models/internal/infobutton-display-dto';

export interface IBasePage {
}

export interface TeslaGridInterface {
    pageSize: number;
    skip: number;
    // gridView: Observable<GridData>;
    data: Object[];
    mainGrid: TeslaGridComponent;
    // title: string;
    ngAfterViewInit(): void;
    fillGrid(): void;
    // pageChange(event: PageChangeEvent): void
}

export abstract class BasePage implements IBasePage {
    // loggerService: NGXLogger
    spinner: SpinnerComponent;
    title: string;
    fieldRequiredMessage = Constants.FIELD_REQUIRED_MESSAGE;
    locStorage = Constants.localStorageKeys;
    IsEmployee: boolean;
    IsReadOnlyUser: boolean;
    IsAdmin: boolean;
    IsSupplier: boolean;
    IsLoggedInAsSupplier: boolean;
    CurrentUserEmail: string;
    infoButtonDisplayDTORefreshed: InfoButtonDisplayDTO;
    // constructor(public appComponent: AppComponent, public sourceType: SourceType, public router?: Router, public route?: ActivatedRoute, public windowTitle?: string) {
    //     if (windowTitle !== undefined && windowTitle !== null && windowTitle !== '') {
    //         document.title = windowTitle;
    //     } else {
    //         document.title = 'Transportation Management System';
    //     }
    // }

    constructor(
        protected localstorageService: LocalstorageService,
        protected logger: NGXLogger,
        protected appSettings: AppSettings) 
        {
        this.setFlags();
        // this.loggerService = logger;
        UIHelper.updateLoggerConfig(appSettings, logger);
    }

    setFlags() {
        this.IsEmployee = this.localstorageService.retrieve(Constants.localStorageKeys.IsEmployee) === Constants.IsEmployeeCheckCode;
        this.IsReadOnlyUser = this.localstorageService.retrieve(Constants.localStorageKeys.IsReadOnlyUser) === Constants.ReadOnlyUserSecurityKey;
        this.IsAdmin = this.localstorageService.retrieve(Constants.localStorageKeys.IsAdmin) === Constants.IsAdminCheckCode;
        this.IsLoggedInAsSupplier = this.localstorageService.retrieve(Constants.localStorageKeys.IsLoggedInAsSupplier) === Constants.IsLoggedAsSupplierSecurityKey;
        this.IsSupplier = this.localstorageService.retrieve(Constants.localStorageKeys.IsSupplier);
        this.CurrentUserEmail = this.localstorageService.retrieve(Constants.localStorageKeys.UserEmail);
        
    }

    RefreshDynamicToolTip(refreshInfoButtonDisplayDTO: InfoButtonDisplayDTO)
    {
        this.infoButtonDisplayDTORefreshed = refreshInfoButtonDisplayDTO;
    }

    scrollToTop() {
        UIHelper.scrollToTop();
    }
    scrollToBottom(pixelsToScroll?: number) {
        UIHelper.scrollToBottom(pixelsToScroll);
    }
    goBack(): void {
        this.clearMessages();
        // this.router.navigate(['../../'], { relativeTo: this.route });
    }
    public logDebug(logMessage?: any, ...optionalParams: any[])
    {
        this.logger.debug(logMessage, optionalParams);
    }
    public logInfo(logMessage: string)
    {
        this.logger.info(logMessage);
    }
    public logError(logMessage: string)
    {
        this.logger.error(logMessage);
    }
    public logWarning(logMessage: string)
    {
        this.logger.warn(logMessage);
    }


    // CheckForUnauthorized(response: any)
    // {
    //      // check for unauthorized code returned
    //      if(response.HttpStatusCode == "Unauthorized")
    //      {
    //          this.router.navigate(['/auth/unauthorized']);
    //      }
    // }

    // displaySnackMessage(message: string, closeMessage: string = 'Close', duration: number = 3000): void {
    //     this.appComponent.snackBar.open(message, closeMessage, {
    //         duration: duration
    //     });
    // }

    clearMessages(): void {
    }
    // public isReadOnlyPage(): boolean {
    //     return this.appComponent.storage !== undefined ? !this.appComponent.storage.IsCurrentPageWrite : true;
    // }
}

export abstract class BaseGridPage extends BasePage implements AfterViewInit, TeslaGridInterface {
    // Grid needed variables
    pageSize = 10;
    skip = 0;
    gridView: Observable<GridData>;
    data: Object[];
    mainGrid: TeslaGridComponent;
    title: string;
    filter: SearchFilter;
    pageSizes: number[] = [10, 25, 50, 100, 250];
    public filtersCollapsed = false;
    public sort: Sort = {
        field: '',
        tag: '',
        ascending: true,
    };
    public subscribers: any = {};
    @ViewChildren(TeslaGridComponent) Grids: QueryList<TeslaGridComponent>;
    location: Location;
    // abstract clear(): void;
    // protected search(): void;
    // abstract ngAfterViewInit(): void;
    constructor(
        localstorageService: LocalstorageService,
        logger: NGXLogger,
        appSettings: AppSettings,

    ) {
        super(localstorageService, logger, appSettings);
    }
    ngAfterViewInit(): void {
        this.subscribers.grids = this.Grids.changes.subscribe(
            (comps: QueryList<TeslaGridComponent>) => {
                if (!this.mainGrid) {
                    if (comps && comps.first) {
                    this.mainGrid = comps.first;
                    this.mainGrid.dataStateChange
                        .pipe(
                            tap(
                                ({
                                    skip,
                                    take,
                                    sort,
                                }: DataStateChangeEvent) => {
                                    this.skip = skip;
                                    this.pageSize = take;
                                    this.sort = sort;
                                }
                            )
                        )
                        .subscribe(x => this.fillGrid());
                    }
                }
            }
        );
    }
    getDemandStatusDescription(demandStatusCode: string) {
        return Helper.getDemandStatusDescription(demandStatusCode);
      }

    getSupplierDisplay(dataItem: any) {
        let name = '';
        if (dataItem.PreferredSupplierName) {
            name = dataItem.PreferredSupplierName;
        } else {
            name = dataItem.SupplierName;
        }
        return UIHelper.supplierDisplayCell(dataItem.SupplierCode, name);
    }

    getSourceTypeDisplay(dataItem: any) {
        return UIHelper.supplierDisplayCell(dataItem.SourceTypeName, dataItem.SourceTypeDescription);
    }

    getWarehouseDisplay(dataItem: any) {
        return UIHelper.supplierDisplayCell(dataItem.WarehouseName, dataItem.WarehouseDescription);
    }

    setFilterCondition(filter: SearchFilter, form: FormGroup, controlName: string, dataType?: number, operator?: number): SearchFilter {
        if (!filter) {
            return filter;
        }

        if (form.get(controlName)) {
            if (!dataType) {
                dataType = Constants.FILTER_DATATYPE_NUMBER;
            }
            if (!operator) {
                operator = Constants.FILTER_OPERATOR_TYPE_EQUAL;
            }
            const value = form.get(controlName).value;
            if (value != null && value !== '') {
            const condition: SearchFilterCondition = new SearchFilterCondition(controlName, value, dataType, operator);
            filter.SearchFilterConditions.push(condition);
            }
        }
        return filter;
    }

    setFilterConditionByField(filter: SearchFilter, field: string, value: string, dataType?: number, operator?: number): SearchFilter {
        if (!filter) {
            return filter;
        }
        
        if (!dataType) {
            dataType = Constants.FILTER_DATATYPE_NUMBER;
        }
        if (!operator) {
            operator = Constants.FILTER_OPERATOR_TYPE_EQUAL;
        }
        
        if (value != null && value !== '') {
        const condition: SearchFilterCondition = new SearchFilterCondition(field, value, dataType, operator);
        filter.SearchFilterConditions.push(condition);
        }
        
        return filter;
    }

    abstract fillGrid(): void;
    // abstract pageChange(event: PageChangeEvent): void

    // constructor(appComponent: AppComponent, sourceType: SourceType, router?: Router, route?: ActivatedRoute, public windowTitle?: string) {
    //     super(appComponent, sourceType, router, route, windowTitle);
    // }
    

    gotoDetail(obj: any) {
        this.clearMessages();
    }
    clearPager(): void {
        this.skip = 0;
    }
    search(): void {
        this.skip = 0;
        this.fillGrid();
    }
    initFilterValues(): void {
        this.filter = new SearchFilter();
    }


}

export abstract class BaseOpenActionsPage  extends BaseGridPage
{
    
}

export abstract class BasePageDetail extends BasePage {
    public IsSaved: boolean = false;
    constructor(appComponent: AppComponent, 
        localstorageService: LocalstorageService, 
        logger: NGXLogger,
        appSettings: AppSettings,
        sourceType: SourceType, router?: Router,
        route?: ActivatedRoute, public windowTitle?: string) {
        super(localstorageService, logger, appSettings);
    }

    abstract getValidations(): boolean;
}
export abstract class BasePageDocumentDetail extends BasePageDetail {
    constructor(appComponent: AppComponent, 
        localstorageService: LocalstorageService, 
        logger: NGXLogger,
        appSettings: AppSettings,
        sourceType: SourceType,
        router?: Router, route?: ActivatedRoute, public windowTitle?: string) {
        super(appComponent, localstorageService, logger, appSettings, sourceType, router, route, windowTitle);
    }
    abstract loadDetail();
}


export abstract class BaseDialogPage implements AfterViewInit, IBasePage, TeslaGridInterface {
    // #Region TeslaGridInterface
    pageSize = 10;
    skip = 0;
    gridView: Observable<GridData>;
    data: Object[];
    mainGrid: TeslaGridComponent;
    // abstract pageChange(event: PageChangeEvent): void
    // #EndRegion TeslaGridInterface
    title: string;
    spinner: TeslaSpinnerComponent;
    abstract fillGrid(): void;
    abstract ngAfterViewInit(): void;
    abstract onClose(event: any): void;

    clearMessages(): void {
        // if (this.errorCard !== null && typeof (this.errorCard !== undefined)) {
        //     this.errorCard.clear();
        // }
    }
}
